const QuizIcon = ({ className }: { className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    className={className}
  >
    <path
      d="M4.5 2C3.11929 2 2 3.11929 2 4.5V11.5C2 12.8807 3.11929 14 4.5 14H11.5C12.8807 14 14 12.8807 14 11.5V4.5C14 3.11929 12.8807 2 11.5 2H4.5ZM3 4.5C3 3.67157 3.67157 3 4.5 3H11.5C12.3284 3 13 3.67157 13 4.5V11.5C13 12.3284 12.3284 13 11.5 13H4.5C3.67157 13 3 12.3284 3 11.5V4.5ZM11.1563 5.92806L6.5 10.5844L4.84375 8.92806C4.64849 8.7328 4.3319 8.7328 4.13664 8.92806C3.94138 9.12333 3.94138 9.43991 4.13664 9.63517L6.14645 11.645C6.34171 11.8402 6.65829 11.8402 6.85355 11.645L11.8634 6.63517C12.0587 6.43991 12.0587 6.12333 11.8634 5.92806C11.6681 5.7328 11.3515 5.7328 11.1563 5.92806Z"
      fill="currentColor"
    />
  </svg>
);

export default QuizIcon;
